import React from 'react';

interface States {
}

interface Props {
    className: string;
}

class Divider extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <div>
                <hr
                    className={this.props.className}/>
            </div>
        )
    }
}

export default Divider;
